import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Label, Box, Optional } from '@honda-canada/design-system-react';
import themeStyles from './styles/PricingDetails.styles';

import DownPaymentInput from './DownPaymentInput';
import FinanceOptions from './FinanceOptions';
import DownPaymentTooltip from './DownPaymentTooltip';

const InputLabel = themeStyles.apply(Label, 'InputLabel');
const FinanceOptionsContainer = themeStyles.apply(Box, 'FinanceOptionsContainer');
const FinanceOptionsWrapper = themeStyles.apply(Box, 'FinanceOptionsWrapper');

const FinanceAndDownpayment = ({ finance, hasPrice, isLoading }) => {
  const { t } = useTranslation();
  return (
    <Optional when={hasPrice && !isLoading}>
      <FinanceOptionsContainer data-testid="cy-price-finance-details">
        <FinanceOptionsWrapper mb="l">
          <FinanceOptions financeOptions={finance} />
        </FinanceOptionsWrapper>
        <InputLabel data-testid="cy-downpayment">
          {t('Sub-apps.PriceAndFinance.downPaymentLabel')}
          <DownPaymentTooltip />
        </InputLabel>
        <DownPaymentInput />
      </FinanceOptionsContainer>
    </Optional>
  );
};

FinanceAndDownpayment.propTypes = {
  finance: PropTypes.shape({}),
  hasPrice: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export default FinanceAndDownpayment;
